import * as fromDatatype from '../datatype-library';

export interface bl_wrty_product_registration_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_name: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_name: fromDatatype.VarcharDatatypeInterface;
  qty: fromDatatype.NumericDatatypeClass;
  serial_no: { serialNumbers: string[] };
  purchase_date: fromDatatype.TimestampTzDatatypeInterface;
  purchased_from: fromDatatype.VarcharDatatypeInterface;
  warranty_period: fromDatatype.VarcharDatatypeInterface;
  warranty_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_wrty_product_registration_hdr_RowClass
  implements bl_wrty_product_registration_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_name: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_name: fromDatatype.VarcharDatatypeInterface;
  qty: fromDatatype.NumericDatatypeClass;
  serial_no: { serialNumbers: string[] };
  purchase_date: fromDatatype.TimestampTzDatatypeInterface;
  purchased_from: fromDatatype.VarcharDatatypeInterface;
  warranty_period: fromDatatype.VarcharDatatypeInterface;
  warranty_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  approval_status: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}